<template>
  <div class="attendee-services-section" v-if="getEnums">
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'servicesControl'" key="create-loading" class="w-100" />
      <el-row v-else key="content-loading" class="w-100 services-details-section">
        <template v-if="services.length > 0">
          <div class="services-item" v-for="item in servicesList" :key="item.id">
            <div class="services-item-wrapper">
              <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeServices.service") }}</span>
              <span
                ><b>{{ getServices(item.additionalServiceId).title }}</b></span
              >
              <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeServices.price") }}</span>
              <span
                ><b>{{ item.price }}</b> {{ getEnumsDisplay("Currency", item.currency) }}</span
              >
              <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeServices.registrationDate") }}</span>
              <span
                ><b>{{ $moment(item.createDate).format("DD MMMM YYYY, ddd") }}</b></span
              >
              <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeServices.linkedPayment") }}</span>
              <span
                ><strong>#{{ item.paymentID }}</strong></span
              >
              <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeServices.confirmationStatus") }}</span>
              <el-dropdown placement="bottom-start">
                <span class="status" :class="{ pending: item.status == 0, 'payment-awaiting': item.status == 1, confirmed: item.status == 2, rejected: item.status == 3 }">
                  <i :class="{ 'fas fa-clock': item.status == 0, 'fas fa-credit-card': item.status == 1, 'fas fa-check-circle': item.status == 2, 'fas fa-times-circle': item.status == 3 }"></i>
                  {{ getEnumsDisplay("ParticipantAdditionalServiceStatus", item.status) }}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="status-pending-approve" v-if="item.status != 2" @click.native="changeAdditionalServiceStatus(item.id, 2)"><i class="fas fa-check"></i> {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeServices.confirm") }}</el-dropdown-item>
                  <el-dropdown-item class="status-pending-reject" v-if="item.status != 3" @click.native="changeAdditionalServiceStatus(item.id, 3)"><i class="fas fa-times"></i> {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeServices.reject") }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div class="attendee-services-edit">
                <el-tooltip class="item" effect="dark" :content='$t("participantManagament.registrationSearch.detailsParticipant.attendeeServices.seeDetails")' placement="top-start">
                  <el-button size="small" icon="fas fa-search" :loading="loading == 'services-question-loading-' + item.id" circle @click="openQuestion(item)"></el-button>
                </el-tooltip>
                <!-- <el-tooltip class="item" effect="dark" :content="$t('event.buttons.edit')" placement="top-start">
                  <el-button type="success" size="small" icon="fas fa-pen" circle></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.delete')" placement="top-start">
                  <el-popconfirm :title="$t('generic.deleteSure')" :cancel-button-text="$t('generic.operationCancel')" :confirm-button-text="$t('generic.deleteYes')" icon-color="red">
                    <el-button type="danger" size="small" icon="fas fa-trash" slot="reference" circle></el-button>
                  </el-popconfirm>
                </el-tooltip> -->
              </div>
            </div>
            <transition name="el-fade-in" mode="out-in">
              <div class="services-registration-section" v-if="item.showQuestion" :key="'showquestion-services-list-' + item.id">
                <div class="services-registration-item" v-for="question in item.questions" :key="'servicequestion-list-item' + question.id">
                  <span>{{ getQuestionOne(question, item.id) != null ? getQuestionOne(question, item.id).title : "Soru silinmiştir." }}</span>
                  <QuestionItem :question="getQuestionOne(question, item.id)" />
                </div>
              </div>
            </transition>
          </div>
        </template>
        <el-alert v-else :show-icon="true" type="info" :title="$t('participantManagament.registrationSearch.detailsParticipant.attendeeServices.noRegistration')"></el-alert>
      </el-row>
    </transition>

    <!-- 
    <div class="services-item">
      <div class="services-item-wrapper">
        <span>Hizmet</span>
        <span><b>Özel transfer</b></span>
        <span>Fiyat</span>
        <span><b>9.000,00</b> TRY</span>
        <span>Kayıt tarihi</span>
        <span><b>11 May 2022, 17:07</b></span>
        <span>Bağlı ödeme</span>
        <span><strong>#V8JJ167L2Z</strong></span>
        <span>Onay durumu</span>
        <el-dropdown placement="bottom-start">
          <span class="status payment-awaiting"><i class="fas fa-credit-card"></i>Ödeme bekliyor</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="status-pending-approve"><i class="fas fa-check"></i> Onayla</el-dropdown-item>
            <el-dropdown-item class="status-pending-reject"><i class="fas fa-times"></i> Reddet</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="attendee-services-edit">
          <el-tooltip class="item" effect="dark" content="Kayıt detaylarını gör" placement="top-start">
            <el-button size="small" icon="fas fa-search" circle @click="showAccomDetails = !showAccomDetails"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.edit')" placement="top-start">
            <el-button type="success" size="small" icon="fas fa-pen" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.delete')" placement="top-start">
            <el-popconfirm :title="$t('generic.deleteSure')" :cancel-button-text="$t('generic.operationCancel')" :confirm-button-text="$t('generic.deleteYes')" icon-color="red">
              <el-button type="danger" size="small" icon="fas fa-trash" slot="reference" circle></el-button>
            </el-popconfirm>
          </el-tooltip>
        </div>
      </div>
      <div class="services-registration-section" v-if="showAccomDetails">
        <div class="services-registration-item">
          <span>Ülke</span>
          <span><b>Türkiye</b></span>
        </div>
        <div class="services-registration-item">
          <span>Şehir</span>
          <span><b>Çorum</b></span>
        </div>
        <div class="services-registration-item">
          <span>Sigara kullanıyor musunuz?</span>
          <span><b>Zehir gibi</b></span>
        </div>
        <div class="services-registration-item">
          <span>Ülke</span>
          <span><b>Türkiye</b></span>
        </div>
        <div class="services-registration-item">
          <span>Şehir</span>
          <span><b>Çorum</b></span>
        </div>
        <div class="services-registration-item">
          <span>Sigara kullanıyor musunuz?</span>
          <span><b>Zehir gibi</b></span>
        </div>
      </div>
    </div>

    <div class="services-item">
      <div class="services-item-wrapper">
        <span>Hizmet</span>
        <span><b>20 m2 stant alanı</b></span>
        <span>Fiyat</span>
        <span><b>9.000,00</b> TRY</span>
        <span>Kayıt tarihi</span>
        <span><b>11 May 2022, 17:07</b></span>
        <span>Bağlı ödeme</span>
        <span><strong>#V8JJ167L2Z</strong></span>
        <span>Onay durumu</span>
        <el-dropdown placement="bottom-start">
          <span class="status confirmed"><i class="fas fa-check-circle"></i>Onaylandı</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="status-pending-approve"><i class="fas fa-check"></i> Onayla</el-dropdown-item>
            <el-dropdown-item class="status-pending-reject"><i class="fas fa-times"></i> Reddet</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="attendee-services-edit">
          <el-tooltip class="item" effect="dark" content="Kayıt detaylarını gör" placement="top-start">
            <el-button size="small" icon="fas fa-search" circle @click="showAccomDetails = !showAccomDetails"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.edit')" placement="top-start">
            <el-button type="success" size="small" icon="fas fa-pen" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.delete')" placement="top-start">
            <el-popconfirm :title="$t('generic.deleteSure')" :cancel-button-text="$t('generic.operationCancel')" :confirm-button-text="$t('generic.deleteYes')" icon-color="red">
              <el-button type="danger" size="small" icon="fas fa-trash" slot="reference" circle></el-button>
            </el-popconfirm>
          </el-tooltip>
        </div>
      </div>
      <div class="services-registration-section" v-if="showAccomDetails">
        <div class="services-registration-item">
          <span>Ülke</span>
          <span><b>Türkiye</b></span>
        </div>
        <div class="services-registration-item">
          <span>Şehir</span>
          <span><b>Çorum</b></span>
        </div>
        <div class="services-registration-item">
          <span>Sigara kullanıyor musunuz?</span>
          <span><b>Zehir gibi</b></span>
        </div>
        <div class="services-registration-item">
          <span>Ülke</span>
          <span><b>Türkiye</b></span>
        </div>
        <div class="services-registration-item">
          <span>Şehir</span>
          <span><b>Çorum</b></span>
        </div>
        <div class="services-registration-item">
          <span>Sigara kullanıyor musunuz?</span>
          <span><b>Zehir gibi</b></span>
        </div>
      </div>
    </div>

    <div class="services-item">
      <div class="services-item-wrapper">
        <span>Hizmet</span>
        <span><b>2 gece çift kişilik konaklama</b></span>
        <span>Fiyat</span>
        <span><b>9.000,00</b> TRY</span>
        <span>Kayıt tarihi</span>
        <span><b>11 May 2022, 17:07</b></span>
        <span>Bağlı ödeme</span>
        <span><strong>#V8JJ167L2Z</strong></span>
        <span>Onay durumu</span>
        <el-dropdown placement="bottom-start">
          <span class="status rejected"><i class="fas fa-times-circle"></i>Reddedildi</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="status-pending-approve"><i class="fas fa-check"></i> Onayla</el-dropdown-item>
            <el-dropdown-item class="status-pending-reject"><i class="fas fa-times"></i> Reddet</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="attendee-services-edit">
          <el-tooltip class="item" effect="dark" content="Kayıt detaylarını gör" placement="top-start">
            <el-button size="small" icon="fas fa-search" circle @click="showAccomDetails = !showAccomDetails"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.edit')" placement="top-start">
            <el-button type="success" size="small" icon="fas fa-pen" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.delete')" placement="top-start">
            <el-popconfirm :title="$t('generic.deleteSure')" :cancel-button-text="$t('generic.operationCancel')" :confirm-button-text="$t('generic.deleteYes')" icon-color="red">
              <el-button type="danger" size="small" icon="fas fa-trash" slot="reference" circle></el-button>
            </el-popconfirm>
          </el-tooltip>
        </div>
      </div>
      <div class="services-registration-section" v-if="showAccomDetails">
        <div class="services-registration-item">
          <span>Ülke</span>
          <span><b>Türkiye</b></span>
        </div>
        <div class="services-registration-item">
          <span>Şehir</span>
          <span><b>Çorum</b></span>
        </div>
        <div class="services-registration-item">
          <span>Sigara kullanıyor musunuz?</span>
          <span><b>Zehir gibi</b></span>
        </div>
        <div class="services-registration-item">
          <span>Ülke</span>
          <span><b>Türkiye</b></span>
        </div>
        <div class="services-registration-item">
          <span>Şehir</span>
          <span><b>Çorum</b></span>
        </div>
        <div class="services-registration-item">
          <span>Sigara kullanıyor musunuz?</span>
          <span><b>Zehir gibi</b></span>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import QuestionItem from "../../register-form/Inputs/QuestionItem.vue";

export default {
  data() {
    return {
      servicesList: [],
      loading: false,
      timeout: null,
      showAccomDetails: false
    };
  },
  components: {
    QuestionItem
  },
  props: {
    participant: Object,
    services: Array,
    additionalServices: Array
  },
  created() {
    this.loading = "servicesControl";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (this.services != undefined && this.services != null) {
        this.servicesList = this.services.map(x => {
          return {
            ...x,
            questionList: [],
            showQuestion: false
          };
        });
      }
      this.loading = false;
    }, 500);
  },
  methods: {
    async openQuestion(item) {
      this.loading = "services-question-loading-" + item.id;
      if (this.timeout != null) clearTimeout(this.timeout);
      if (item.showQuestion) {
        item.showQuestion = !item.showQuestion;
        this.loading = false;
      } else {
        this.timeout = setTimeout(async () => {
          var responsoQuestions = await this.$store.dispatch("getQuestionsObject", { id: this.participant.registrationFormId, type: 1 });
          item.questionList = responsoQuestions.data.data.items;
          item.showQuestion = !item.showQuestion;
          this.loading = false;
        }, 500);
      }
    },
    getQuestionOne(question, serviceID) {
      var allQuestions = this.servicesList.find(x => x.id == serviceID).questionList;
      var returned = allQuestions.find(x => x.registrationInputID == question.registrationInputID);
      if (returned == null) {
        return returned;
      }
      returned.answer = question.answer;
      returned.answers = question.answers;
      return returned;
    },
    getServices(id) {
      return this.additionalServices.find(x => x.id == id);
    },
    async changeAdditionalServiceStatus(id, status) {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var payload = {
          id: this.participant.id,
          additionalServiceId: id,
          status: status,
          cancellationReason: null
        };
        if (status != 3) {
          var res = await this.$store.dispatch("changeAdditionalServiceStatus", payload);
          if (!res.data.alert.hasError) {
            this.$emit("refresh");
          }
        } else {
          if (this.$i18n.locale == "tr") {
            var reason = await this.$prompt("Lütfen bir sebep belirtin.", "Uyarı", {
              confirmButtonText: "Tamam",
              cancelButtonText: "Vazgeç",
              inputPattern: /(.|\s)*\S(.|\s)*/,
              inputErrorMessage: "Lütfen boş bırakmayınız."
            })
              .then(async ({ value }) => {
                payload.cancellationReason = value;
                var res = await this.$store.dispatch("changeAdditionalServiceStatus", payload);
                if (!res.data.alert.hasError) {
                  this.$emit("refresh");
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "İşlem iptal edildi."
                });
              });
          } else {
            var reason = await this.$prompt("Please provide a reason.", "Warning", {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              inputPattern: /(.|\s)*\S(.|\s)*/,
              inputErrorMessage: "Please fill in all fields."
            })
              .then(async ({ value }) => {
                payload.cancellationReason = value;
                var res = await this.$store.dispatch("changeAdditionalServiceStatus", payload);
                if (!res.data.alert.hasError) {
                  this.$emit("refresh");
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "The process has been cancelled."
                });
              });
          }
        }
      }, 500);
    }
  },
  computed: {
    getEnums() {
      return this.$store.getters.getEnums;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/participants/ParticipantDetails/AttendeeServices.vue